export enum Granularity {
    YEAR = "year",
    MONTH = "month",
    DAY = "day",
    HOUR = "hour"
}